import { EnumEnvs } from '@library/store/config/config.interface';

declare global {
  interface Window {
      env: {
        envDomain: string
      }
  }
}
export const environment= {
  project: 'settings-velux',
  authUrl: "https://auth.inte.velux-active.com",
  apiUrl: "https://app.inte.netatmo.com/api/",
  langsUrl: "/langs/",
  syncApiUrl: "https://app.inte.netatmo.com/syncapi/v1/",
  cookiePrefix: "inteveluxactivecom",
  env: EnumEnvs.INTEGRATION,
  production: false
};
